// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { AbstractQueryParams, TypesaurusCoreDoc } from '@res/ngg-core';
import { MachineDoc, MachineRef, ServicingModel, ServicingRef, ServicingUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ServicingActions {
  export class GetAllServicing {
    static readonly type = '[Servicing] GetAllServicing';
    readonly type = GetAllServicing.type;
  }

  export class InitServicing {
    static readonly type = '[Servicing] InitServicing';
    /**
     * The machines the caller owns, or undefined for an admin.
     *
     * Firestore evaluates a list rule against every document the query returns and fails the whole
     * query if one of them fails, so an unscoped listener is rejected outright for a partner rather
     * than filtered down. `/servicing`'s list rule admits a document whose `belongsTo` is one of
     * the caller's machines, which is exactly what constraining the query to these refs produces.
     */
    constructor(public machineRefs?: MachineRef[]) {}
  }

  export class CloseServicingConnection {
    static readonly type = '[Servicing] CloseServicingConnection';
    readonly type = CloseServicingConnection.type;
  }

  export class GetServicingById {
    static readonly type = '[Servicing] GetServicingById';
    readonly type = GetServicingById.type;
  }

  export class UpdateServicing {
    constructor(
      public servicingData: Partial<ServicingUpdateData>,
      public ref: ServicingRef,
    ) {}
    static readonly type = '[Servicing] UpdateServicing';
  }

  export class UpdateServicingResult {
    static readonly type = '[Servicing] UpdateServicingResult';
    constructor(public data: Array<TypesaurusCoreDoc<ServicingModel> | null | undefined>) {}
  }

  export class DeleteServicing {
    static readonly type = '[Servicing] DeleteServicing';
    readonly type = DeleteServicing.type;
  }

  export class QueryServicing {
    static readonly type = '[Servicing] QueryServicing';

    constructor(
      public filter: {
        query: AbstractQueryParams<ServicingModel>[];
      },
    ) {}
  }

  export class SetSelectedMachine {
    static readonly type = '[Servicing] SetSelectedMachine';

    constructor(public selectedMachine: MachineDoc) {}
  }

  export class ServicingError {
    static readonly type = '[Servicing] ServicingError';

    constructor(public error: Error) {}
  }
}
